/* eslint-disable react/require-default-props */
import React from 'react';
import cx from 'classnames';
import capitalize from 'lodash.capitalize';
import { ButtonProps as MaterialButtonProps } from '@mui/material/Button';
import { CircularProgress } from '@mui/material';
import { StyledMaterialButton } from './styles';

interface ButtonProps extends MaterialButtonProps {
    component?: any;
    loading?: boolean;
}

const Button = React.forwardRef((props: ButtonProps, ref: React.Ref<any>) => {
    const {
        type = 'button',
        color = 'primary',
        variant = 'contained',
        size = 'medium',
        children,
        fullWidth = false,
        className,
        component,
        loading,
        startIcon,
        ...otherProps
    } = props;
    const btnClassName = cx(
        'root',
        `btn${capitalize(size)}`,
        `btn${capitalize(color)}${capitalize(variant)}`,
        {
            btnFullWidth: fullWidth,
            'btn-full-Width': fullWidth,
        },
        `btn-${size}`,
        `btn-${variant}`,
        className,
    );
    const StyledButtonAny = StyledMaterialButton as any;
    return (
        // eslint-disable-next-line react/button-has-type
        <StyledButtonAny
            {...otherProps}
            type={type ?? 'button'}
            className={btnClassName}
            ref={ref}
            component={component}
            startIcon={loading ? <CircularProgress size={20} className="mr-2" /> : startIcon}
        >
            {children}
        </StyledButtonAny>
    );
});

export default Button;
